<template>
  <v-dialog
    v-if="dialog"
    v-model="dialog"
    max-width="800"
    >
    <v-card>
      <v-card-title class="headline primary lighten-1 white--text">
        Edit Image
      </v-card-title>
      <v-card-text>
        <span>
          <input type="file" @change="dragNdrop($event)"  @dragover.prevent="drag()" @drop.prevent="drop()" id="uploadFile"  />
        </span>
        <v-card-text v-if="currentPictureBase64">
          <v-img :max-width="300" :src="currentPictureBase64"></v-img>
        </v-card-text>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" flat @click="dialog=false">
          <v-icon>fa-times</v-icon>
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          flat
          @click="saveGraphic(); dialog = false"
        >
          <v-icon>fa-save</v-icon>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EditGraphics',
  props: {
    note: Object
  },
  data () {
    return {
      dialog: false,
      currentPictureBase64: false
    }
  },
  methods: {
    showEditor () {
      this.dialog = true
      this.currentPictureBase64 = this.note.pictureBase64
    },
    saveGraphic: function () {
      let note = this.note
      note.pictureBase64 = this.currentPictureBase64
      this.$store.commit('editStickie', note)
    },
    dragNdrop (event) {
      let file = event.target.files[0]
      if (file.type.match(/image.*/)){
        this.readFile(file)
      } else {
        console.log('File type not supported')
      }
    },
    readFile (file) {
      let self = this
      if (file) {
        let reader = new FileReader()
        reader.onload = function (event) {
          self.currentPictureBase64 = event.target.result
        }
        reader.readAsDataURL(file)
      }

    },
    drag () {
      document.getElementById('uploadFile').parentNode.className = 'dragging dragBox'
    },
    drop () {
      document.getElementById('uploadFile').parentNode.className = 'dragBox'
    }

  }
}
</script>

<style scoped>
.uploadOuter {
  text-align: center;
  padding: 20px;
  strong {
    padding: 0 10px
  }
}
.dragBox {
  width: 250px;
  height: 100px;
  margin: 0 auto;
  position: relative;
  text-align: center;
  font-weight: bold;
  line-height: 95px;
  color: #999;
  border: 2px dashed #ccc;
  display: inline-block;
  transition: transform 0.3s;
  input[type="file"] {
    position: absolute;
    height: 100%;
    width: 100%;
    opacity: 0;
    top: 0;
    left: 0;
  }
}
.draging {
  transform: scale(1.1);
}
#preview {
  text-align: center;
  img {
    max-width: 100%
  }
}
</style>
